/** 年次 = sent this calendar year, 月次 = sent this calendar month. Date is yyyy/MM/dd. */
export function matchesInvitationPeriod(sentDate: string, period: string, now = new Date()): boolean {
  if (!period) return true;
  const match = /^(\d{4})\/(\d{2})\/\d{2}$/.exec(sentDate.trim());
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  if (period === 'yearly') return year === now.getFullYear();
  if (period === 'monthly') return year === now.getFullYear() && month === now.getMonth() + 1;
  return true;
}
